import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { TicketDialogService } from '../ticket-dialog.service';
import { RequestTicket } from './request-ticket.schema';

@Component({
  selector: 'tellent-assistant-ticket-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <article class="card" role="button" tabindex="0" (click)="open()" (keydown.enter)="open()">
      <header>
        <span class="status" [class]="'status--' + payload().status">{{ payload().status }}</span>
        <h4>{{ payload().name }}</h4>
      </header>
      @if (payload().description) {
        <p class="description">{{ payload().description }}</p>
      }
      @if (payload().assignee) {
        <footer>Assigned: {{ payload().assignee!.name }}</footer>
      }
    </article>
  `,
  styleUrls: ['./tellent-assistant-ticket-card.component.less'],
})
export class TellentAssistantTicketCardComponent {
  public readonly payload = input.required<RequestTicket>();

  private readonly dialog = inject(TicketDialogService);

  protected open(): void {
    this.dialog.openTicketDialog(this.payload().id, { routerStrategy: false });
  }
}
